export function mediaSingleSlider() {
    let $slider = $(".media-single-slider");
    $slider.each(function () {
        let $this = $(this);
        $this.slick({
            infinite: false,
            fade: true,
            slidesToScroll: 1,
            slidesToShow: 1,
            dots: false,
            prevArrow: "<button type='button' class='slick-prev slick-arrow'><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"8\" height=\"14\" viewBox=\"0 0 8 14\" fill=\"none\">\n" +
                "  <path d=\"M6.5 12L1.5 7L6.5 2\" stroke=\"#160C55\" stroke-width=\"2.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                "</svg></button>",
            nextArrow: "<button type='button' class='slick-next slick-arrow'><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"8\" height=\"14\" viewBox=\"0 0 8 14\" fill=\"none\">\n" +
                "  <path d=\"M1.5 12L6.5 7L1.5 2\" stroke=\"#160C55\" stroke-width=\"2.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n" +
                "</svg></button>",
        }).on('beforeChange', function () {
            $this.find(".image-holder").removeClass("video-play");
            $this.find('video,iframe').remove();
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/mediaSingleSlider.js